import { getExampleNumber, parsePhoneNumberFromString, validatePhoneNumberLength } from 'libphonenumber-js/max';
import mobileExamples from 'libphonenumber-js/examples.mobile.json';

// Is the number a customer can text? libphonenumber's full metadata gives the number type from its range.
// - North America (+1, NANP): landlines can be text-enabled, so a non-mobile type is only a warning.
// - Elsewhere (e.g. EU): SMS to a landline, VoIP, toll-free or an unknown range (M2M / IoT, unassigned)
//   will most likely not arrive: shown in red, still allowed.
// Returns null while the number is still being typed.
const TYPE_LABEL = {
    FIXED_LINE: 'landline',
    VOIP: 'VoIP',
    TOLL_FREE: 'toll-free',
    PREMIUM_RATE: 'premium-rate',
    SHARED_COST: 'shared-cost',
    PERSONAL_NUMBER: 'personal number',
    PAGER: 'pager',
    UAN: 'company (UAN)',
    VOICEMAIL: 'voicemail'
};

export const numberCheck = raw => {
    const text = String(raw || '').trim();
    const digits = text.replace(/\D/g, '');
    if (digits.length < 6) return null;
    const value = text.startsWith('+') ? text : `+${digits}`;
    const lengthError = validatePhoneNumberLength(value);
    if (lengthError === 'TOO_SHORT') return null;
    const parsed = parsePhoneNumberFromString(value);
    if (!parsed || !parsed.isValid()) {
        // Shorter than this country's mobile numbers: still being typed, say nothing yet.
        const example = parsed?.country ? getExampleNumber(parsed.country, mobileExamples) : null;
        if (example && parsed.nationalNumber.length < example.nationalNumber.length) return null;
        return {level: 'err', code: lengthError === 'TOO_LONG' ? 'TOO_LONG' : 'INVALID', country: parsed?.country || null};
    }
    const type = parsed.getType();
    const nanp = parsed.countryCallingCode === '1';
    const base = {country: parsed.country || null, type: type || null, nanp};
    if (type === 'MOBILE') return {...base, level: 'ok', code: 'MOBILE'};
    if (type === 'FIXED_LINE_OR_MOBILE') return {...base, level: 'ok', code: 'MOBILE_OR_LANDLINE'};
    const label = TYPE_LABEL[type] || null;
    if (nanp) return {...base, level: 'warn', code: 'NANP_NOT_MOBILE', label};
    return {...base, level: 'err', code: type ? 'NOT_MOBILE' : 'UNKNOWN_RANGE', label};
};
